function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.15 7.907H8.839v2h11.31v-2zM16.09 14.37H4.83v2H16.09v-2z",
  fill: "#005646"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.268 18.363c-1.655 0-3.015-1.353-3.015-3s1.36-3 3.015-3a2.995 2.995 0 012.985 3c0 1.647-1.33 3-2.985 3zm0-4.53c-.828 0-1.537.677-1.537 1.53s.68 1.53 1.537 1.53c.827 0 1.537-.677 1.537-1.53s-.71-1.53-1.537-1.53zM7.122 11.9c-1.647 0-3-1.353-3-3s1.353-3 3-3 3 1.353 3 3-1.353 3-3 3zm0-4.5c-.823 0-1.53.676-1.53 1.53 0 .852.677 1.529 1.53 1.529.824 0 1.53-.677 1.53-1.53S7.945 7.4 7.121 7.4z",
  fill: "#005646"
});

function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgFilterIcon;